const armenianMonths = [
    "Հունվար",
    "Փետրվար",
    "Մարտ",
    "Ապրիլ",
    "Մայիս",
    "Հունիս",
    "Հուլիս",
    "Օգոստոս",
    "Սեպտեմբեր",
    "Հոկտեմբեր",
    "Նոյեմբեր",
    "Դեկտեմբեր",
]

// Function to pad numbers with leading zeros
const padZero = (num) => {
    return num.toString().padStart(2, "0")
}
export const formatDateNow = (dateString, language, isFullFormat) => {
    if (!dateString) return ""

    const date = new Date(dateString)

    // Handle invalid dates
    if (isNaN(date.getTime())) {
        console.error("Invalid date:", dateString)
        return ""
    }
    try {

        // Special handling for Armenian
        if (language === "hy") {
            const day = date.getDate()
            const month = armenianMonths[date.getMonth()]
            const year = date.getFullYear()
            const hours = padZero(date.getHours())
            const minutes = padZero(date.getMinutes())

            // Format: Day Month Year, Hours:Minutes
            if (isFullFormat) {
                return `${day} ${month} ${year}թ, ${hours}:${minutes}`
            } else {
                // Format: Day Month Year
                return `${day} ${month} ${year}թ`
            }

        }

        if (isFullFormat) {
            return date.toLocaleString(language, {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            })
        } else {
            return date.toLocaleString(language, {
                year: "numeric",
                month: "long",
                day: "numeric",
            })
        }
    } catch (error) {
        console.error("Error formatting date:", error)
    }
}
